import { useState } from "react";
import axios from "axios";
import { SITE } from "@/lib/site";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState(sessionStorage.getItem("porter_admin_key") || "");
  const [leads, setLeads] = useState(null);
  const [error, setError] = useState("");

  const load = async (e) => {
    e?.preventDefault();
    setError("");
    try {
      const res = await axios.get(`${API}/leads`, { headers: { "X-Admin-Key": key } });
      sessionStorage.setItem("porter_admin_key", key);
      setLeads(res.data.leads);
    } catch {
      setError("Invalid admin key.");
      setLeads(null);
    }
  };

  return (
    <div className="min-h-screen bg-cream px-5 py-16 sm:px-8">
      <div className="mx-auto max-w-4xl" data-testid="admin-page">
        <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-gold-dark">Porter New Orleans</p>
        <h1 className="mt-4 font-serif text-4xl text-navy">Website Leads</h1>
        <p className="mt-3 text-sm text-navy/60">
          Private view for {SITE.legalName}. Every submission from the website contact form appears here.
        </p>

        {leads === null ? (
          <form onSubmit={load} className="mt-10 flex max-w-md gap-3" data-testid="admin-login-form">
            <Input
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Admin key"
              data-testid="admin-key-input"
              className="h-12 rounded-xl border-navy/15 bg-white"
            />
            <button
              type="submit"
              data-testid="admin-login-button"
              className="rounded-full bg-navy px-7 text-sm font-bold text-cream transition-colors hover:bg-navy-light"
            >
              View
            </button>
          </form>
        ) : (
          <>
            <p className="mt-8 text-sm font-semibold text-navy/70" data-testid="admin-lead-count">
              {leads.length} lead{leads.length === 1 ? "" : "s"}
            </p>
            <div className="mt-4 space-y-4">
              {leads.map((lead) => (
                <article key={lead.id} className="rounded-2xl border border-navy/10 bg-white p-6" data-testid={`admin-lead-${lead.id}`}>
                  <div className="flex flex-wrap items-baseline justify-between gap-2">
                    <h2 className="font-serif text-2xl text-navy">{lead.name}</h2>
                    <span className="rounded-full bg-gold/15 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-gold-dark">
                      {lead.status}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-navy/50">
                    {new Date(lead.created_at).toLocaleString()} · {lead.source}
                  </p>
                  <dl className="mt-4 grid gap-2 text-sm text-navy/80 sm:grid-cols-2">
                    <div><dt className="inline font-semibold">Email: </dt><dd className="inline"><a className="text-gold-dark underline" href={`mailto:${lead.email}`}>{lead.email}</a></dd></div>
                    <div><dt className="inline font-semibold">Phone: </dt><dd className="inline">{lead.phone || "—"}</dd></div>
                    <div><dt className="inline font-semibold">Topic: </dt><dd className="inline">{lead.topic}</dd></div>
                    <div><dt className="inline font-semibold">Prefers: </dt><dd className="inline">{lead.preferred_contact}</dd></div>
                  </dl>
                  <p className="mt-4 border-t border-navy/10 pt-4 text-sm leading-relaxed text-navy/75">{lead.message}</p>
                </article>
              ))}
              {leads.length === 0 && (
                <p className="rounded-2xl border border-navy/10 bg-white p-8 text-center text-sm text-navy/60">
                  No leads yet — new website inquiries will appear here.
                </p>
              )}
            </div>
          </>
        )}
        {error && <p className="mt-4 text-sm font-semibold text-red-700" data-testid="admin-error">{error}</p>}
      </div>
    </div>
  );
}
